import { Component } from '@angular/core';

import './new-core-poc.scss';

/**
 * Component that shows if new-core is available in apps
 *
 * @example
 * <new-core-poc></new-core-poc>
 */
@Component({
  selector: 'new-core-poc',
  template: require('./new-core-poc.html').default,
})
export class NewCorePoc {
  constructor() {}
}
